module.exports = __webpack_public_path__ + "img/zdly_bg.5ab8cf8.png";